import { formatDate } from '@angular/common'
import { TravelDates } from './travel-dates'

export class ListingLink {
    public routerLink: string[]

    constructor(public listingId: string, public travelDates: TravelDates, public isPublicListing?: boolean) {

        if (this.isPublicListing) {
            this.routerLink = ['/public-listing', listingId]
            return
        }

        if (this.travelDates?.checkin) {
            let checkinSlug = formatDate(this.travelDates.checkin, 'yyyy-MM-dd', "en_US")
            let checkoutSlug = formatDate(this.travelDates.checkout, 'yyyy-MM-dd', "en_US")
            this.routerLink = ['/listing', listingId, checkinSlug, checkoutSlug]
        } else {
            this.routerLink = ['/listing', listingId]
        }
    }

    toPath(): string {
        return this.routerLink.join('/')
    }
}
